import moment from "moment";
import "moment/locale/es";
import { cuentaMask, round2Decimals } from "../Components/Items";

moment.locale("es");

const to2 = (n) =>
  Number.isFinite(n)
    ? round2Decimals(n)?.toFixed?.(2) ?? (Math.round(n * 100) / 100).toFixed(2)
    : "0.00";

const reporteResumenEntradasSalidasPdf = (values) => {
  const empresa = values.empresa;
  const logoBiwo = values.logoBiwo;

  // ------------------- Filtros (incluye periodo) -------------------
  const filtrados = [];

  const start = values?.rango?.startDate
    ? moment(values.rango.startDate).format("LL")
    : moment(values.periodo?.[0]).format("LL");
  const end = values?.rango?.endDate
    ? moment(values.rango.endDate).format("LL")
    : moment(values.periodo?.[1]).format("LL");

  filtrados.push([
    { text: "Periodo:", style: "subheader" },
    { text: `Del ${start} al ${end}`, style: "textoChico" },
  ]);

  if (values.filtrarProyecto === 1 && Array.isArray(values.proyectos)) {
    let textoFiltrado = "";
    values.proyectos.forEach((p) => (textoFiltrado += `${p.nombre}\n`));
    filtrados.push([
      { text: "Proyectos:", style: "subheader" },
      { text: textoFiltrado, style: "textoChico" },
    ]);
  }

  if (values.filtrarProyecto === 2 && values.unidadDeNegocio) {
    filtrados.push([
      { text: "Unidad de Negocio:", style: "subheader" },
      {
        text:
          cuentaMask(
            values.unidadDeNegocio.nivel1 +
              values.unidadDeNegocio.nivel2 +
              values.unidadDeNegocio.nivel3 +
              values.unidadDeNegocio.nivel4 +
              values.unidadDeNegocio.nivel5
          ) +
          " - " +
          values.unidadDeNegocio.nombre,
        style: "textoChico",
      },
    ]);
  }

  if (filtrados.length === 0) {
    filtrados.push([
      { text: "No tiene filtrados adicionales", style: "subheader" },
      { text: "", style: "textoChico" },
    ]);
  }

  // ------------------- Encabezados de tabla -------------------
  // Una sola fila combinada (Normal + Apartado sumados)
  const headerRow = [
    { text: "Clave",       style: "tituloTabla", alignment: "center" },
    { text: "Descripción", style: "tituloTabla", alignment: "center" },
    { text: "Familia",     style: "tituloTabla", alignment: "center" },
    { text: "Inicial",     style: "tituloTabla", alignment: "center" },
    { text: "Entradas",    style: "tituloTabla", alignment: "center" },
    { text: "Salidas",     style: "tituloTabla", alignment: "center" },
    { text: "Final",       style: "tituloTabla", alignment: "center" },
    { text: "Costo Ini.",  style: "tituloTabla", alignment: "center" },
    { text: "Costo Ent.",  style: "tituloTabla", alignment: "center" },
    { text: "Costo Sal.",  style: "tituloTabla", alignment: "center" },
    { text: "Costo Fin.",  style: "tituloTabla", alignment: "center" },
  ];

  const inventarioRows = (values.inventario || []).map((it) => [
    { text: it.claveInsumo || "",       style: "textoTabla", alignment: "left", noWrap: false },
    { text: it.descripcionInsumo || "", style: "textoTabla", alignment: "left", noWrap: false },
    { text: it.nombreFamilia || "",     style: "textoTabla", alignment: "left", noWrap: false },

    { text: to2((it.inicial || 0) + (it.inicialApartado || 0)),                       style: "textoTabla", alignment: "right" },
    { text: to2((it.entradas || 0) + (it.entradasApartado || 0)),                     style: "textoTabla", alignment: "right" },
    { text: to2((it.salidas || 0) + (it.salidasApartado || 0)),                       style: "textoTabla", alignment: "right" },
    { text: to2((it.final || 0) + (it.finalApartado || 0)),                           style: "textoTabla", alignment: "right" },
    { text: to2((it.costoTotalInicial || 0) + (it.costoTotalInicialApartado || 0)),   style: "textoTabla", alignment: "right" },
    { text: to2((it.costoTotalEntradas || 0) + (it.costoTotalEntradasApartado || 0)), style: "textoTabla", alignment: "right" },
    { text: to2((it.costoTotalSalidas || 0) + (it.costoTotalSalidasApartado || 0)),   style: "textoTabla", alignment: "right" },
    { text: to2((it.costoTotalFinal || 0) + (it.costoTotalFinalApartado || 0)),       style: "textoTabla", alignment: "right" },
  ]);

  const r = values.resumen || {};
  const ra = values.resumenApartado || {};

  const totalesRow = [
    { text: "TOTAL", style: "subheader", alignment: "left" },
    { text: "", border: [false, false, false, false] },
    { text: "", border: [false, false, false, false] },

    { text: to2((r.totalInicial || 0) + (ra.totalInicialApartado || 0)),                 style: "subheader", alignment: "right" },
    { text: to2((r.totalEntradas || 0) + (ra.totalEntradasApartado || 0)),               style: "subheader", alignment: "right" },
    { text: to2((r.totalSalidas || 0) + (ra.totalSalidasApartado || 0)),                 style: "subheader", alignment: "right" },
    { text: to2((r.totalFinal || 0) + (ra.totalFinalApartado || 0)),                     style: "subheader", alignment: "right" },
    { text: to2((r.costoTotalInicial || 0) + (ra.costoTotalInicialApartado || 0)),       style: "subheader", alignment: "right" },
    { text: to2((r.costoTotalEntradas || 0) + (ra.costoTotalEntradasApartado || 0)),     style: "subheader", alignment: "right" },
    { text: to2((r.costoTotalSalidas || 0) + (ra.costoTotalSalidasApartado || 0)),       style: "subheader", alignment: "right" },
    { text: to2((r.costoTotalFinal || 0) + (ra.costoTotalFinalApartado || 0)),           style: "subheader", alignment: "right" },
  ];

  const dd = {
    footer: { image: "logoBiwo", alignment: "center", width: 80 },

    content: [
      // === INFO ===
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          layout: { defaultBorder: false },
          body: [[
            { border: [false, false, false, false], image: "logo", fit: [80, 80] },
            {
              border: [false, false, false, false],
              table: {
                headerRows: 1,
                widths: ["100%"],
                body: [
                  [{
                    text: empresa.nombreComercial
                      ? empresa.nombreComercial
                      : (empresa.persona
                          ? empresa.nombre
                          : `${empresa.nombre} ${empresa.apellidoPaterno} ${empresa.apellidoMaterno}`),
                    style: "tableHeader"
                  }],
                  [{ text: "R.F.C: " + (empresa.rfc || ""), style: "textoChico", alignment: "center" }],
                  [{ text: `${empresa.calle || ""} ${empresa.numeroCalle || ""} ${empresa.numeroInterior || ""}`, style: "textoChico", alignment: "center" }],
                  [{
                    text: `${empresa.colonia?.tipoAsentamiento || ""} ${empresa.colonia?.nombre || ""} C.P. ${empresa.colonia?.cp || ""} ${empresa.municipio?.nombre || ""} ${empresa.estado?.abreviatura || ""} ${empresa.pais?.abreviatura || ""}`,
                    style: "textoChico",
                    alignment: "center"
                  }],
                  [{ text: "REPORTE DE ENTRADAS Y SALIDAS DE INVENTARIO", style: "tableHeader" }],
                ],
              },
              layout: "noBorders",
            },
            {
              border: [false, false, false, false],
              table: {
                headerRows: 1,
                widths: ["100%"],
                body: [
                  [{ text: "Fecha de Impresión:", style: "subheader", alignment: "center" }],
                  [{ text: moment().locale("es").format("LL"), style: "textoChico", alignment: "center" }],
                ],
              },
              layout: "noBorders",
            },
          ]],
        },
      },

      { text: "Datos de filtrado:" },
      {
        style: "tableExample",
        table: {
          widths: ["20%", "80%"],
          layout: { defaultBorder: false },
          body: filtrados,
        },
        layout: {
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          hLineColor: () => "#adaaaa",
          vLineColor: () => "#adaaaa",
          hLineStyle: (i, node) => (i === 0 || i === node.table.body.length ? null : { dash: { length: 2, space: 1 } }),
          vLineStyle: (i, node) => (i === 0 || i === node.table.widths.length ? null : { dash: { length: 2 } }),
        },
      },

      // === TABLA ===
      {
        style: "tableExample",
        table: {
          // 11 columnas total: 3 + 4 cant + 4 costos
          widths: [
            "8%",   // Clave
            "26%",  // Descripción
            "12%",  // Familia
            "6%","6%","6%","6%",       // Cantidades
            "7.5%","7.5%","7.5%","7.5%", // Costos
          ],
          headerRows: 1,
          body: [
            headerRow,
            ...inventarioRows,
            totalesRow,
          ],
        },
        layout: {
          paddingLeft: () => 2,
          paddingRight: () => 2,
          paddingTop: () => 2,
          paddingBottom: () => 2,
          fillColor: (rowIndex) => (rowIndex < 1 ? null : rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff"),
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          hLineColor: () => "#adaaaa",
          vLineColor: () => "#adaaaa",
          hLineStyle: (i, node) => (i === 0 || i === node.table.body.length ? null : { dash: { length: 2, space: 1 } }),
          vLineStyle: (i, node) => (i === 0 || i === node.table.widths.length ? null : { dash: { length: 2 } }),
        },
      },
    ],

    images: {
      logo: empresa.logo.base64Completa,
      logoBiwo: logoBiwo.base64Completa,
    },

    styles: {
      header:       { fontSize: 9, bold: true },
      subheader:    { fontSize: 8, bold: true },
      tableExample: { margin: [0, 5, 0, 5] },
      tablaSinMargen: { margin: [0, 0, 0, 0] },
      tableHeader:  { bold: true, fontSize: 12, color: "black", alignment: "center" },
      textoChico:   { fontSize: 8 },
      tituloTabla:  { fontSize: 7, bold: true, fillColor: "#cccccc", alignment: "center", border: true },
      textoTabla:   { fontSize: 7, italics: false },
    },

    pageSize: "LETTER",
    pageOrientation: "landscape",
    pageMargins: [20, 20, 20, 60],
  };

  return dd;
};

export default reporteResumenEntradasSalidasPdf;
